import { FormEvent } from 'react';
import { useAuth } from '../../hooks';

interface MagicLinkFormProps {
  email: string;
  onEmailChange: (email: string) => void;
  buttonLabel: string;
  onBeforeSubmit?: () => void;
  redirect?: string;
}

export function MagicLinkForm({ email, onEmailChange, buttonLabel, onBeforeSubmit, redirect }: MagicLinkFormProps) {
  const { sendMagicLink, loading } = useAuth();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    onBeforeSubmit?.();

    try {
      await sendMagicLink(email, redirect);
    } catch {
      // Error is handled by useAuth
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="fieldset">
        <label htmlFor="magic-link-email" className="fieldset-legend">
          Email
        </label>
        <input
          id="magic-link-email"
          name="email"
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          required
          autoComplete="email"
          className="input w-full"
          placeholder="you@example.com"
        />
      </div>

      <div className="pt-2">
        <button
          type="submit"
          disabled={loading}
          className="btn btn-primary w-full"
        >
          {loading ? 'Sending...' : buttonLabel}
        </button>
      </div>
    </form>
  );
}
